import RestUtilities, { IRestResponse } from "./RestUtilities";
import IServer from "../models/IServer"

export default class Servers {
  static async fetchAll(): Promise<IRestResponse<IServer[]>> {
    return await RestUtilities.get<IServer[]>("/api/tenant/servers");
  }
}
